declare namespace $ {

	export class $mol_icon_shield_crown extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=crown.view.tree.d.ts.map